






import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Dock extends Vue {
  @Prop() private src!: string;
  @Prop() private width!: string;
  @Prop() private onClick?: () => void;

  private handleClick = () => {
    if (this.onClick) {
      this.onClick();
    }
  };
}
